import { store } from "../redux/storeConfig/store";

import { history } from "../app/AppRouter";
import { setLoginFlag, setLoginUser } from "../redux/actions/login/loginAction";
import { toastr } from "react-redux-toastr";
const axios = require("axios");
const mainUrl = process.env.REACT_APP_SERVER_URL;

export const api = async (endpoint, data, type, responseType, cancelToken) => {
  var res;
  var user = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
  if (user) {
    var token = user.token;
  }

  switch (type) {
    case "post":
      await axios({
        data: data,
        method: "post",
        headers: {
          // "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          "x-auth": token,
        },
        url: mainUrl + endpoint,
      })
        .then(function(response) {
          res = response;
        })
        .catch((err) => {
          if (err.response.status === 423) {
            res = err.response;
          } else if (err.response.status === 400) {
            res = err.response;
          } else if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 503
          ) {
            localStorage.removeItem("user");
            store.dispatch(setLoginFlag(false));
            store.dispatch(setLoginUser({}));
            history.push("/");
          } else res = err;
        });
      break;
    case "get":
      const options = {
        method: "get",
        headers: {
          // "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          "x-auth": token,
        },

        url: mainUrl + endpoint,
      };
      if (responseType) {
        options.responseType = responseType;
      }
      if (cancelToken) {
        options.cancelToken = cancelToken;
      }
      await axios(options)
        .then(function(response) {
          res = response;
        })
        .catch((err) => {
          if (!err.response || !err.response.status) {
            return;
          }
          if (err.response.status === 400) {
            res = err.response;
          } else if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 503
          ) {
            localStorage.removeItem("user");
            store.dispatch(setLoginFlag(false));
            store.dispatch(setLoginUser({}));
            history.push("/");
          } else  res = err;

        });
      break;
    case "patch":
      await axios({
        method: "patch",
        data: data,
        headers: {
          // "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          "x-auth": token,
        },
        url: mainUrl + endpoint,
      })
        .then(function(response) {
          res = response;
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 404) {
            res = err.response;
          } else if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 503
          ) {
            localStorage.removeItem("user");
            store.dispatch(setLoginFlag(false));
            store.dispatch(setLoginUser({}));
            history.push("/");
          } else res = err;
        });
      break;
    case "delete":
      await axios({
        data: data,
        method: "delete",
        headers: {
          // "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
          "x-auth": token,
        },
        url: mainUrl + endpoint,
      })
        .then(function(response) {
          res = response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            res = err.response;
          } else if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 503
          ) {
            localStorage.removeItem("user");
            store.dispatch(setLoginFlag(false));
            store.dispatch(setLoginUser({}));
            history.push("/");
          } else res = err
        });
      break;
    case "postWithoutToken":
      await axios({
        method: "post",
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
        url: mainUrl + endpoint,
      })
        .then(function(response) {
          res = response;
        })
        .catch((err) => {
          res = err.response;
        });
      break;
    default:
      return true;
  }

  // var parsdata = await checkData(res);
  return res;
};

export const checkData = (data) => {
  return true;
};

export const generateCancelTokenSource = () => {
  return axios.CancelToken.source(); // Create a new CancelToken source
};

export const isCancelAxios = (err) => {
  return axios.isCancel(err);
};
